import { IAIApproverLocationsResponse, IAIApproverOutlierReportResponse, IAIApproverQCReportResponse, IAIApproverRepDetailsPayload, IAIApproverReportPayload, IPlotDetailsResponse, IPlotStatusChangePayload, IPlotUserAction, IRepDataResponse } from "../models/IAIApprover.model";
import { URLConfig } from "../network/urlStore";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";

export const getAllLocations = (crop: string, season: number): Observable<IAIApproverLocationsResponse> => {
	const url = URLConfig.getAIApproverLocationsURL(crop, season);
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(res: unknown) => {
				if (res) {
					const response = res as unknown as IAIApproverLocationsResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while fetching AI approver locations", error);
			}
		);
	});
};

export const getAIApproverRepDetails = (
	payload: IAIApproverRepDetailsPayload,
): Observable<IRepDataResponse> => {
	let url = URLConfig.postAIApproverRepDetailByLocationURL();
	return new Observable((subscriber) => {
		NetworkService.post(url, payload).then(
			(res: unknown) => {
				if (res) {
					const response = res as IRepDataResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while fetching AI approver rep details", error);
			}
		);
	});
};

export const getAIApproverPlotDetailsByRep = (
	repId: number,
): Observable<IPlotDetailsResponse> => {
	let url = URLConfig.getAIApproverPlotDetailsByRep(repId);
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(res: unknown) => {
				if (res) {
					const response = res as IPlotDetailsResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while fetching AI approver plot details", error);
			}
		);
	});

};

export const postPlotStatusChange = (
	repId: number,
	payload: IPlotStatusChangePayload,
): Observable<any> => {
	let url = URLConfig.postPlotStatusChange(repId);
	return new Observable((subscriber) => {
		NetworkService.post(url, payload).then(
			(res: unknown) => {
				if (res) {
					const response = res as any;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while posting plot status change", error);
			}
		);
	});
};

export const getAIApproverOutlierReport = (
	payload: IAIApproverReportPayload,
): Observable<IAIApproverOutlierReportResponse> => {
	let url = URLConfig.getOutlierReportURL();
	return new Observable((subscriber) => {
		NetworkService.post(url, payload).then(
			(res: unknown) => {
				if (res) {
					const response = res as IAIApproverOutlierReportResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while fetching AI approver outlier report", error);
			}
		);
	});
};

export const getAIApproverQCReport = (
	payload: IAIApproverReportPayload,
): Observable<IAIApproverQCReportResponse> => {
	let url = URLConfig.getQcReportURL();
	return new Observable((subscriber) => {
		NetworkService.post(url, payload).then(
			(res: unknown) => {
				if (res) {
					const response = res as IAIApproverQCReportResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: Error) => {
				subscriber.error(error);
				console.log("Error while fetching AI approver QC report", error);
			}
		);
	});
};
